<template>
  <div>
    <div class="row">
      <div class="col-8">
        <breadcrumb :page="page" />
      </div>
      <div class="col-4 h-16 mt-5">
        <div class="row btn-group student-btn-group-save px-4">
          <div v-if="$route.params.fromTabII" class="col-12 my-2">
            <ActionButton
              variant="outline-success"
              i="fa fa-arrow-circle-left"
              @click="goBacktoTabII"
            >
              Regresar a la parte II del PEI
            </ActionButton>
          </div>
          <div v-else-if="$route.params.fromTabVIII" class="col-12 my-2">
            <ActionButton
              variant="outline-success"
              i="fa fa-arrow-circle-left"
              @click="goBacktoTabVIII"
            >
              Regresar a la parte VIII del PEI
            </ActionButton>
          </div>
          <div v-else class="col-6 mx-0">
            <ActionButton
              variant="outline-success"
              i="fa fa-arrow-circle-left"
              @click="goBack"
            >
              Regresar
            </ActionButton>
          </div>
          <div class="col-6 mx-0">
            <button id="btnFA" class="btn btn-action btn-green pt-1">
              <i class="fas fa-save pr-2" />
              Guardar
            </button>
            <ActionButton
              variant="outline-success"
              i="fa fa-save"
              @click="goBack"
            >
              Regresar
            </ActionButton>
          </div>
        </div>
      </div>
    </div>

    <!-- Separator -->
    <div class="dropdown-divider pb-4 w-100" />

    <!-- Informacion de la Determinacion -->
    <div class="tag-badge-info">
      <span class="tag-badge-title-info">
        Informaci&oacute;n de la Determinaci&oacute;n
      </span>
    </div>

    <!-- Separator -->
    <div class="dropdown-divider pb-2 w-100" />

    <div class="panel-simple">
      <div class="header global-thead-dark">
        <div class="col-md-7">
          <span class="d-flex">
            Informaci&oacute;n General del Proceso de Determinaci&oacute;n de
            Elegibilidad
          </span>
        </div>
        <div class="col-md-5">
          <span class="d-flex">A&ntilde;o Acad&eacute;mico:</span>
        </div>
      </div>

      <div class="container-fluid bg-rectangle-gradiant" />

      <div class="panel-row-without-selector pb-4 mb-5">
        <div class="col-md-7 info">
          <span>
            <b>Fecha</b>
          </span>
          <div id="datepicker" class="datepicker">
            <i class="far fa-calendar-day" />
            <span>22/nov/2019</span>
          </div>
        </div>
        <div class="col-md-5 info">
          <span>
            <b>Cambiar el impedimento?</b>
          </span>

          <div class="input-group mb-3">
            <input id="input1" type="radio" class="hidden" name="inputs" />
            <label class="entry" for="input1">
              <div class="circle" />
              <div class="entry-label">Si</div>
            </label>

            <input id="input2" type="radio" class="hidden" name="inputs" />
            <label class="entry" for="input2">
              <div class="circle" />
              <div class="entry-label">No</div>
            </label>

            <div class="highlight" />
          </div>
        </div>
      </div>
    </div>
    <!-- Comentario -->
    <div class="tag-badge-info">
      <span class="tag-badge-title-info">Comentario</span>
    </div>

    <!-- Separator -->
    <div class="dropdown-divider mt-0 pb-4 w-100" />

    <textarea
      id
      class="form-control textarea"
      name
      cols="30"
      rows="5"
      placeholder="Escribir comentario..."
      maxlength="3000"
    />

    <!-- Separator -->
    <div class="dropdown-divider mt-0 pb-4 w-100" />

    <!-- Documentos de Respaldo al Proceso de Determinacion -->
    <div class="tag-badge-info">
      <span class="tag-badge-title-info">
        Documentos de Respaldo al Proceso de Determinaci&oacute;n
      </span>
    </div>

    <!-- Separator -->
    <div class="dropdown-divider mt-0 pb-2 w-100" />

    <div class="panel-simple">
      <div class="header global-thead-dark">
        <div class="col-md-12">
          <span>Documento de Respaldo</span>
        </div>
      </div>

      <!-- INICIO: Html de boton para documento de respaldo -->
      <div v-if="!addDocument">
        <div class="bg-rectangle-gradiant" />

        <div class="panel-row-without-selector mb-4 pb-4">
          <div class="col-12 text-center">
            <button
              id="btnFA"
              class="btn bg-light-white w-75 pt-1"
              @click="addDocument = true"
            >
              <i class="fas fa-file-plus pr-4 text-green" />
              <span class="text-button-add-document">
                Presione aqu&iacute; para a&ntilde;adir documento de respaldo
              </span>
            </button>
          </div>
        </div>
      </div>
      <!-- FIN: Html de boton para documento de respaldo -->

      <!-- INICIO: Html al precionar boton -->
      <div v-if="addDocument">
        <div class="container-fluid bg-rectangle-gradiant-absolute" />
        <div class="panel-row-without-selector subtitle">
          <div class="tag-badge-referred">
            <span class="dot-info-rev">
              <i class="fas fa-plus orange-icon" />
            </span>
            <span class="tag-badge-title-info">
              A&ntilde;adir Documento de Respaldo
            </span>
          </div>
        </div>

        <div class="container-fluid bg-rectangle-gradiant" />

        <div class="panel-row-without-selector mb-4 pb-4">
          <div class="col-md-4 info">
            <p class="p-title">
              <strong>Nombre</strong>
            </p>
            <input
              type="text"
              class="form-control w-100"
              placeholder="Nombre*"
            />
          </div>
          <div class="col-md-3 info">
            <p class="p-title">
              <strong>Tipo</strong>
            </p>
            <select class="control-input w-100">
              <option>Seleccione</option>
            </select>
          </div>
          <div class="col-md-2" />
          <div class="col-md-3 info">
            <p class="p-title" />
            <div class="center-box">
              <button
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
            </div>
          </div>
        </div>

        <div class="d-flex flex-row-reverse bd-highlight w-100 mb-5">
          <div class="mx-0 bd-highlight ml-2">
            <button class="btnFA btn btn-action btn-green">
              <i class="fas fa-file-plus pr-2" />
              Guardar
            </button>
          </div>
          <div class="mx-0 bd-highlight">
            <button
              class="btnFA btn btn-outline-danger btn-cancel"
              @click="addDocument = false"
            >
              <i class="fas fa-times-circle pr-1" />
              Cancelar
            </button>
          </div>
        </div>
      </div>
      <!-- FIN: Html al precionar boton -->
    </div>

    <!-- Informacion de Evaluaciones -->
    <div class="col-12">
      <div class="tag-badge-info">
        <span class="tag-badge-title-info">
          Informaci&oacute;n de Evaluaciones
        </span>
      </div>
      <div class="dropdown-divider mt-0 pb-2 w-100" />
    </div>

    <div class="col-12">
      <ErrorComponent
        v-if="
          !validate &&
            (evaluationInformationData == null ||
              evaluationInformationData.length <= 0)
        "
        message="Es necesario que seleccione al menos una evaluación durante la discusión."
        variant="withoutspacing"
      />

      <EvaluationInformationLayout
        :get="getEvaluationInformation"
        :evaluation-saved="!isEnabled"
        @data="gettingEvaluationInformation"
      />
    </div>

    <!-- Separator -->
    <div class="dropdown-divider mt-0 pb-2 w-100" />

    <div class="container-table-striped">
      <div class="table-hover">
        <table class="table content-table-striped table-striped mb-5">
          <thead>
            <tr class="row global-thead-dark thead-property pl-1">
              <th class="col-4">
                <span class="d-flex">Nombre</span>
              </th>
              <th class="col-4">
                <span class="d-flex">Puesto</span>
              </th>
              <th class="col-4" />
            </tr>
          </thead>
          <tbody>
            <tr class="row pl-4">
              <td class="col-md-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Escribir nombre"
                />
              </td>
              <td class="col-md-3 pl-3">
                <select class="control-input w-100">
                  <option>Seleccione</option>
                </select>
              </td>
              <td class="col-md-2" />
              <td class="col-md-3">
                <div class="center-box">
                  <button
                    class="btn btn-dropdown-actions dropdown-toggle pt-1 pl-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                </div>
              </td>
            </tr>

            <tr class="row pl-4">
              <td class="col-md-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Escribir nombre"
                />
              </td>
              <td class="col-md-3 pl-3">
                <select class="control-input w-100">
                  <option>Seleccione</option>
                </select>
              </td>
              <td class="col-md-2" />
              <td class="col-md-3">
                <div class="center-box">
                  <button
                    class="btn btn-dropdown-actions dropdown-toggle pt-1 pl-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                </div>
              </td>
            </tr>

            <tr class="row pl-4">
              <td class="col-md-4">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Escribir nombre"
                />
              </td>
              <td class="col-md-3 pl-3">
                <select class="control-input w-100">
                  <option>Seleccione</option>
                </select>
              </td>
              <td class="col-md-2" />
              <td class="col-md-3">
                <div class="center-box">
                  <button
                    class="btn btn-dropdown-actions dropdown-toggle pt-1 pl-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex flex-row-reverse bd-highlight w-100 mb-5">
          <div class="mx-0 bd-highlight ml-2">
            <button
              id="agregar-firma-participante"
              class="btnFA btn btn-action btn-green"
            >
              <i class="fas fa-file-plus pr-2" />
              A&ntilde;adir
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import EvaluationInformationLayout from '@/components/studentEvaluation/EvaluationInformationLayout';
import ErrorComponent from '@/components/common/Error';

export default {
  components: {
    breadcrumb,
    EvaluationInformationLayout,
    ErrorComponent,
  },
  data: () => ({
    page: {
      icon: 'fas fa-user-edit',
      title: 'Estudiante: Proceso de Evaluación Trianual',
      routes: ['Inicio', 'PEI', 'Estudiante: Proceso de Evaluación Trianual'],
    },
    getEvaluationInformation: false,
    evaluationInformationData: [],
    addDocument: false,
    validate: true,
    isEnabled: true,
  }),
  methods: {
    async generateEvaluationInformation() {
      this.getEvaluationInformation = true;
      // Espero a traermo los datos del $emit.
      await this.$nextTick();
      this.getEvaluationInformation = false;
    },
    async ValidateEvaluationInformation() {
      // Valido la lista de de evaluaciones.
      await this.generateEvaluationInformation();
      this.validate = true;
    },

    // Generate data for send.
    async generateData() {
      await this.generateEligibilityDetermination();
      await this.generateEvaluationInformation();
      await this.generateParticipantSignatures();
    },
    goBacktoTabII() {
      let self = this;
      self.$root.$router.push('/pei/detail?tab=Tab2');
    },
    goBacktoTabVIII() {
      let self = this;
      self.$root.$router.push('/pei/detail?tab=Tab8');
    },
    goBack() {
      let self = this;
      self.$router.go(-1);
    },
    gettingEvaluationInformation() {},
  },
};
</script>

<style scoped src="@/assets/css/component/textarea.css"></style>
<style scoped src="@/assets/css/component/radio-button.css"></style>
<style scoped src="@/assets/css/component/datepicker.css"></style>
<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped src="@/assets/css/component/messages.css"></style>
<style scoped src="@/assets/css/component/badge.css"></style>
<style scoped src="@/assets/css/component/btn-dropdown.css"></style>
